import type { SelectOption } from '@chopchop-se/ui';
import { useQuery } from '@tanstack/react-query';

import { listRestaurants } from './api';

/**
 * Restaurant options for the mapping picker.
 *
 * Kept out of `lookups.ts` because it is scoped data: the API narrows this list
 * to what the caller may see (`RestaurantsService.scopeFor`), so it is never
 * safe to treat as a global reference set the way units and categories are.
 */
export function useRestaurantOptions(): SelectOption[] {
  const { data } = useQuery({
    queryKey: ['master-data', 'lookup', 'restaurants'],
    queryFn: () => listRestaurants({ page: 1, pageSize: 500, sort: 'name' }),
    staleTime: 5 * 60_000,
  });
  return (data?.items ?? []).map((restaurant) => ({
    value: restaurant.id,
    label: `${restaurant.name} (${restaurant.code})`,
  }));
}
